import { motion } from "framer-motion";
import { Anchor, Footprints, Check } from "lucide-react";
import { useSiteLang } from "../lib/siteLang";

const TourCard = ({ photo, tag, title, text, items, Icon, accent, testId }) => (
  <motion.article
    initial={{ y: 28 }}
    whileInView={{ y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    className="app-card overflow-hidden flex flex-col card-hover"
    data-testid={testId}
  >
    <div className="relative h-56 md:h-64">
      <img src={photo} alt="" className="w-full h-full object-cover" loading="lazy" />
      <div className="absolute inset-0 photo-scrim" />
      <div className="absolute left-6 bottom-5 flex items-center gap-3">
        <span className="w-11 h-11 rounded-full flex items-center justify-center text-white" style={{ backgroundColor: accent }} aria-hidden="true">
          <Icon className="w-5 h-5" />
        </span>
        <span className="font-bold text-white text-lg">{tag}</span>
      </div>
    </div>
    <div className="p-7 md:p-8 flex-1">
      <h3 className="text-2xl text-white mb-3" style={{ textWrap: "balance" }}>{title}</h3>
      <p className="mb-5" style={{ color: "rgba(255,255,255,0.72)" }}>{text}</p>
      <ul className="space-y-2.5">
        {items.map((item) => (
          <li key={item} className="flex items-start gap-3 text-white">
            <Check className="w-5 h-5 mt-0.5 shrink-0" style={{ color: accent }} aria-hidden="true" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  </motion.article>
);

export const Tours = () => {
  const { t } = useSiteLang();

  return (
    <section id="tours" className="section-padding bg-[#09101F]" data-testid="tours-section">
      <div className="max-w-6xl mx-auto px-5 md:px-10">
        <div className="mb-12 md:mb-16 max-w-2xl">
          <p className="section-label mb-4">{t.toursLabel}</p>
          <h2 className="text-3xl md:text-5xl text-white" style={{ textWrap: "balance" }}>{t.toursTitle}</h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-6">
          <TourCard
            testId="tour-sea"
            photo="/images/photo-marina-grande.webp"
            Icon={Anchor}
            accent="#00B4D8"
            tag={t.sea.tag}
            title={t.sea.title}
            text={t.sea.text}
            items={t.sea.items}
          />
          <TourCard
            testId="tour-land"
            photo="/images/photo-amalfi.webp"
            Icon={Footprints}
            accent="#FF6B00"
            tag={t.land.tag}
            title={t.land.title}
            text={t.land.text}
            items={t.land.items}
          />
        </div>
      </div>
    </section>
  );
};
